import type { App, Plugin } from 'vue';
import { createVNode, h, render } from 'vue';

import Modals from '../components/Modals/Modals.vue';

export interface ModalsPluginOptions {
  mountNodeClass?: string;
  mountNodeId?: string;
}

export const DEFAULT_MODALS_PLUGIN_NODE_ID = 'stash-modals-mount-node';

export default <Plugin>{
  install(app: App, options?: ModalsPluginOptions) {
    const mountNodeId = options?.mountNodeId || DEFAULT_MODALS_PLUGIN_NODE_ID;
    let mountNode = document.getElementById(mountNodeId);

    if (!mountNode) {
      mountNode = document.createElement('div');
      mountNode.id = mountNodeId;
      mountNode.dataset.test = DEFAULT_MODALS_PLUGIN_NODE_ID;
      document.body.appendChild(mountNode);
    }

    if (options?.mountNodeClass && !mountNode.classList.contains(options.mountNodeClass)) {
      mountNode.classList.add(options.mountNodeClass);
    }

    const vNode = createVNode(h(Modals));
    vNode.appContext = app._context;

    render(vNode, mountNode);
  },
};
